
import DashboardLayout from '../pages/Dashboard/Layout/DashboardLayout'

const DynamicReportExec = () => import('../pages/DynamicReports/Exec')

const idealExtranet = {
  path: '/',
  component: DashboardLayout,
  name: 'IdealExtranet',
  title: 'IDEAL',
  icon: 'info',
  excludedGroups: [ 'Extranet' ],
  excludedRoles: [ 'IDEAL' ],
  children: [
    {
      path: '/ideal/reporte-fechas',
      name: 'Reporte de Fechas',
      title: 'Reporte de Fechas',
      component: DynamicReportExec,
      props: () => ({
        report: 'reporte-ideal-fechas'
      }),
      meta: {
        ifUserCan: {
          can_view_ideal_date: 'DynamicReports/report',
        },
      },
    },
    {
      path: '/ideal/archivo-compartido',
      name: 'Archivo Compartido',
      title: 'Archivo Compartido',
      component: DynamicReportExec,
      props: () => ({
        report: 'archivo-compartido',
        editable: true,
      }),
      meta: {
        ifUserCan: {
          can_view_ideal_share_file: 'DynamicReports/report',
        },
      },
    },
  ],
}
export default idealExtranet



// WEBPACK FOOTER //
// ./src/router/idealRoutes.js